import requests, { setToken } from "./httpServices";
import { showErrorAlert } from "./AlertService";

const AdminServices = {
  getAllSchools: async (params) => {
    try {
      const token = localStorage.getItem("token"); // Get token from localStorage
      setToken(token);
      const response = await requests.get("/admin/get-all-schools", { params });
      return response;
    } catch (error) {
      showErrorAlert(error);
      throw error;
    }
  },
  getAllTeachers: async (params) => {
    try {
      const token = localStorage.getItem("token"); // Get token from localStorage
      setToken(token);
      const response = await requests.get("/admin/get-all-teachers", {
        params,
      });
      return response;
    } catch (error) {
      showErrorAlert(error);
      throw error;
    }
  },
  getSchoolTeachers: async (param) => {
    try {
      const token = localStorage.getItem("token"); // Get token from localStorage
      setToken(token);
      const response = await requests.get(
        "/admin/get-all-school-teachers?school_id=" + param.school_id,
        { param }
      );
      return response;
    } catch (error) {
      showErrorAlert(error);
      throw error;
    }
  },
  getAllInfluences: async () => {
    try {
      const token = localStorage.getItem("token"); // Get token from localStorage
      setToken(token);
      const response = await requests.get("/admin/get-all-influencers");
      return response;
    } catch (error) {
      showErrorAlert(error);
      throw error;
    }
  },
};

export default AdminServices;
